import script from "./MainView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainView.vue?vue&type=script&lang=ts&setup=true"

import "./MainView.vue?vue&type=style&index=0&id=e0c25f0e&lang=css"

const __exports__ = script;

export default __exports__